module.exports = __webpack_public_path__ + "static/media/for-sale.90f35fa0.svg";